import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Menu, Spin } from 'antd';
import { css } from '@emotion/core';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import { theme } from '../../constants';
import { RowFlex } from '../common/FlexStyle';
import IconSvg from '../common/IconSvg';
import { Notifications } from './styled';

@inject('notificationsStore')
@observer
class NotificationsMenu extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }
  setLoading = val => {
    this.setState({ loading: val });
  };

  loadMore = e => {
    const {
      notificationsStore: { fetchNextPage, total, notifications },
    } = this.props;
    const { loading } = this.state;
    if (
      !loading &&
      notifications.length < total &&
      Math.abs(
        e.target.scrollHeight - e.target.scrollTop - e.target.getBoundingClientRect().height,
      ) < 1
    ) {
      this.setLoading(true);
      fetchNextPage(true).then(() => {
        this.setLoading(false);
      });
    }
  };

  scrollMenuToTop = () => {
    document.getElementById('tm-notifications-list').scrollTop = 0;
  };

  render() {
    const {
      notificationsStore: {
        totalNotSeen,
        notifications,
        markSeenAllNotifications,
        // isBetaUser,
      },
    } = this.props;
    const { loading } = this.state;
    const { mobileLayout } = this.props;
    return (
      <Dropdown
        // disabled={process.env.REACT_APP_ENV === 'prod' && !isBetaUser}
        key="header-item-user"
        trigger={['click']}
        onVisibleChange={vis => {
          if (!vis) {
            this.scrollMenuToTop();
          }
        }}
        overlay={
          <Menu
            id="tm-notifications-list"
            onScroll={this.loadMore}
            css={css`
              width: ${mobileLayout ? '300px' : '350px'};
              max-height: 50vh;
              overflow-y: auto;
              & .inactive-menu-item {
                cursor: auto;
                user-select: none;
                &:hover {
                  background: white;
                }
              }
            `}
          >
            <Menu.Item
              className="inactive-menu-item"
              css={css`
                & h2 {
                  font-size: ${theme.fontSize.large};
                  font-weight: bold;
                  margin-bottom: -10px;
                }
              `}
            >
              <RowFlex
                css={css`
                  justify-content: space-between;
                  align-items: center;
                `}
              >
                <h2>Notifications</h2>
                {totalNotSeen > 0 && (
                  <Button
                    size="small"
                    onClick={() => {
                      markSeenAllNotifications();
                    }}
                  >
                    Mark all seen
                  </Button>
                )}
              </RowFlex>
            </Menu.Item>
            {notifications.length ? (
              notifications.map(notification => (
                <Menu.Item
                  css={css`
                    white-space: initial;
                    padding: 5px 0 5px 20px;
                    color: ${notification.wasSeen
                      ? theme.colors.greySecondary
                      : theme.colors.greyDark};
                    background-color: ${notification.wasSeen
                      ? theme.colors.whiteBackground
                      : theme.colors.whiteMediumBackground};
                  `}
                  key={`header-item-${notification.id}`}
                  onClick={() => {
                    notification.markSeen();
                    notification.handleClick();
                  }}
                >
                  {!notification.wasSeen && (
                    <div
                      css={css`
                        background: ${theme.colors.blueLight};
                        margin-right: 6px;
                        margin-left: -12px;
                        display: inline-block;
                        height: 7px;
                        width: 7px;
                        border-radius: 3.5px;
                      `}
                    />
                  )}
                  {notification.description}
                  <div
                    css={css`
                      ${!notification.wasSeen && `color: ${theme.colors.blueLight};`}
                    `}
                  >
                    {moment
                      .utc(notification.timestamp)
                      .local()
                      .fromNow()}
                  </div>
                </Menu.Item>
              ))
            ) : (
              <Menu.Item className="inactive-menu-item">
                <RowFlex
                  css={css`
                    flex-direction: column;
                    align-items: center;
                    & > h3 {
                      color: ${theme.colors.greyMid};
                      font-size: ${theme.fontSize.medium};
                      margin-top: 10px;
                    }
                  `}
                >
                  <IconSvg type="notifications-bell" size="60" color={theme.colors.greyLight} />
                  <h3>All caught up!</h3>
                </RowFlex>
              </Menu.Item>
            )}
            {notifications.length && loading && (
              <Menu.Item className="inactive-menu-item">
                <RowFlex
                  css={css`
                    justify-content: center;
                  `}
                >
                  <Spin />
                </RowFlex>
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <span>
          <Notifications count={totalNotSeen} />
        </span>
      </Dropdown>
    );
  }
}

NotificationsMenu.propTypes = {
  notificationsStore: PropTypes.object,
};

export default NotificationsMenu;
